import {
	getGoalSiteAri,
	getProjectSiteAri,
} from '@atlassian/projects-goals-common/get-app-site-ari';
import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';

import SavedViewUpdatesAsideAggRootQueryNode, {
	type SavedViewUpdatesAsideAggRootQuery,
} from '../SavedViewUpdates/agg/__generated__/SavedViewUpdatesAsideAggRootQuery.graphql';

export const savedViewUpdatesAsideAggResource: RouteResource<
	PreloadedQuery<SavedViewUpdatesAsideAggRootQuery, Record<string, unknown>>
> = createRelayResource<SavedViewUpdatesAsideAggRootQuery>({
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;
		const shouldFetchGoalsData = context.townsquareApp !== 'projects';
		const shouldFetchProjectsData = context.townsquareApp !== 'goals';

		const containerId = shouldFetchGoalsData
			? getGoalSiteAri(context.collabContext?.contextId || '')
			: getProjectSiteAri(context.collabContext?.contextId || '');

		return {
			query: SavedViewUpdatesAsideAggRootQueryNode,
			variables: {
				containerId,
				directoryId: routerContext.match.params.uuid || '',
				shouldFetchGoalsData,
				shouldFetchProjectsData,
			},
			options: {
				fetchPolicy: 'store-and-network',
			},
			environment: getAggRelayEnvironment(),
		};
	},
});
